import { useNavigate } from "react-router";
import { CreateUnifiedOrderDialog } from "./unified/create-unified-order-dialog";

export function CreateOrderPage() {
  const navigate = useNavigate();
  const close = () => {
    void navigate("/fulfillment/orders");
  };
  return (
    <CreateUnifiedOrderDialog
      open
      onOpenChange={(open) => {
        if (!open) close();
      }}
      onSuccess={close}
    />
  );
}
